import OpenAI from 'openai';
import { ChatMessage, ChatError } from '@/types/chat';
import { IMMIGRATION_ASSISTANT_PROMPT } from './systemPrompt';

const MAX_RETRIES = 3;
const RETRY_DELAY_MS = 2000;

export const createChatMessages = (
  text: string,
  conversationHistory: ChatMessage[] = []
): ChatMessage[] => {
  return [
    {
      role: "system",
      content: IMMIGRATION_ASSISTANT_PROMPT
    },
    ...conversationHistory,
    {
      role: "user",
      content: text
    }
  ];
};

export const handleChatError = (error: ChatError): string => {
  if (error.message?.includes('invalid_api_key')) {
    return "API key inválida. Por favor, contacta al administrador.";
  }
  if (error.message?.includes('insufficient_quota')) {
    return "La cuota de API se ha agotado. Por favor, contacta al administrador.";
  }
  if (error.status === 429) {
    return "Se ha excedido el límite de solicitudes. Por favor, intenta más tarde.";
  }
  return "Hubo un error al procesar tu pregunta. Por favor, inténtalo de nuevo.";
};

export const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));